import { render, staticRenderFns } from "./OfferForm.vue?vue&type=template&id=68ae4b1d&scoped=true&"
import script from "./OfferForm.vue?vue&type=script&lang=js&"
export * from "./OfferForm.vue?vue&type=script&lang=js&"
import style0 from "./OfferForm.vue?vue&type=style&index=0&id=68ae4b1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ae4b1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68ae4b1d')) {
      api.createRecord('68ae4b1d', component.options)
    } else {
      api.reload('68ae4b1d', component.options)
    }
    module.hot.accept("./OfferForm.vue?vue&type=template&id=68ae4b1d&scoped=true&", function () {
      api.rerender('68ae4b1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/OfferForm.vue"
export default component.exports